import ModalButton from "@/app/shared/modal-button";
import PageBread from "@/app/shared/page-bread";
import TablePro from "@/components/table-pro";
import { useTanStackTablePro } from "@/components/table-pro/custom/use-TanStack-Table-Pro";
import TableFooterPro from "@/components/table-pro/footer";
import TablePaginationPro from "@/components/table-pro/pagination";
import { Operation } from "@/Core/Client";
import { FieldValues } from "react-hook-form";
import { Box } from "rizzui";
import { Config } from "./crud-config";
import CrudFormElements from "./crud-form-elements";
import { Filters } from "./filters";

export default function CrudPage<
    R extends Record<string, any>,
    F extends FieldValues,
>({ config }: { config: Config<R, F> }) {
    // set a title in the config file
    config.titles.pageTitle ??= (config.endPoint ?? "")?.split("/")[1];
    config.titles.pageCreateTitle ??= "Create Form";
    config.titles.pageEditTitle ??= "Edit Form";

    // } else {
    config.filterProps ??= { useDrawer: true, ignoreSorting: true };
    config.formOptions ??= { customSize: "750px" };
    // config.filterProps!.useDrawer ??= true;
    // config.filterProps!.ignoreSorting ??= false;
    config.filterProps.ignoreSorting ??= true;
    // }

    config.fields
        .filter((f) => f.hasFilter)
        .forEach((f) => {
            f.filter = f.filter ?? {
                operation: Operation.eq,
                showOperations: false,
                ignoreOperators: [],
            };
            // f.filter.operation ??= Operation.eq;
            // f.filter.showOperations ??= false;
        });

    config.fields?.forEach((f) => {
        f.filter ??= { operation: Operation.eq, showOperations: false };
        f.filterOnly ??= false;
        f.hasFilter ??= false;
        f.createFormOnly ??= false;
    });

    const { table, isPending } = useTanStackTablePro<R>({
        queryKey: config.queryKey,
        endPoint: config.endPoint,
        columnConfig: config.columns,
        options: config.columnsOptions,
    });

    return (
        <>
            <PageBread title={config.titles.pageTitle}>
                <div className="mt-4 flex items-center gap-3 @lg:mt-0">
                    <ModalButton
                        permission={config.permissionsCreate}
                        label="Add"
                        customSize={config.formOptions?.customSize}
                        view={<CrudFormElements<R, F> config={config} />}
                        path={config.formPageRoute}
                    />
                </div>
            </PageBread>

            <Box>
                <Filters config={config} table={table} />

                <TablePro
                    table={table}
                    variant="modern"
                    isLoading={isPending}
                    classNames={{
                        container: "border border-muted rounded-md",
                        rowClassName: "last:border-0",
                    }}
                />
                <TableFooterPro table={table} />
                <TablePaginationPro table={table} className="py-4" />
            </Box>
        </>
    );
}
